// extracted by mini-css-extract-plugin
module.exports = {"module":"JurisdictionFlag_module__1IFzl"};